import { render } from "./vueButton.vue?vue&type=template&id=2888bd30&scoped=true"
import script from "./vueButton.vue?vue&type=script&lang=js"
export * from "./vueButton.vue?vue&type=script&lang=js"

import "./vueButton.vue?vue&type=style&index=0&id=2888bd30&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2888bd30"]])

export default __exports__